import { ElementType, ReactNode } from 'react';
import styles from './Section.module.scss';

interface SectionProps {
  children: ReactNode;
  className?: string;
  as?: ElementType;
  padding?: string;
}

/**
 * Section — a reusable wrapper that applies the glass-card mixin styles.
 * Replaces manual `<section className={styles.section}>` patterns across pages.
 */
export function Section({ children, className, as: Tag = 'section', padding }: SectionProps) {
  const combinedClassName = [styles.section, className].filter(Boolean).join(' ');
  const inlineStyle = padding ? { padding } : undefined;

  return (
    <Tag className={combinedClassName} style={inlineStyle}>
      {children}
    </Tag>
  );
}

export default Section;
